/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable default-param-last */
/* eslint-disable no-console */
import localForage from "localforage";
import { calculateIndexedDBSize } from "./CachedDBSize.js";
import { CacheSizeProvider, DBMAXSIZE } from "./CacheSizeProvider.js";

const TTFREVIEWCACHEIDENTIFIER = "TTFREVIEW";
const VALIDFORDAYS = 2;

const getExpiryDate = (date = new Date(), noOfDays) => {
  const cloneDate = new Date(date);
  const validForDays = noOfDays || VALIDFORDAYS;
  cloneDate.setDate(date.getDate() + validForDays);
  return cloneDate;
};

export const TTFReviewCacheProvider = () => {
  const DBCacheSize = CacheSizeProvider();
  const cacheProvider = localForage.createInstance({
    name: TTFREVIEWCACHEIDENTIFIER
  });

  const getItem = async (key, successCallback) => {
    try {
      const cachedValue = await cacheProvider.getItem(key);
      return cachedValue && cachedValue.data;
    } catch (error) {
      console.log(
        `Encountered an error while retreiving value for key: ${key} and Error: {error}`
      );
      return null;
    }
  };

  const removeItem = async (key) => {
    try {
      await cacheProvider.removeItem(key);
    } catch (error) {
      console.log(
        `Encountered an error while removing item for key: ${key} and Error: ${error}`
      );
    }
  };

  const cleanUpExpiredItems = () => {
    return new Promise((resolve, reject) => {
      const currentDate = new Date();
      cacheProvider
        .iterate((value, localforageKey) => {
          if (!value) return;
          const { expiresOn } = value;
          if (currentDate < new Date(expiresOn)) return;
          removeItem(localforageKey);
        })
        .then(() => {
          resolve("success");
        })
        .catch((err) => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(`error: ${err}`);
        });
    });
  };

  const setItem = async (key, data) => {
    try {
      await cleanUpExpiredItems();
      await calculateIndexedDBSize();
      const cacheSize = await DBCacheSize.getItem("TTFREVIEW");
      if (cacheSize && cacheSize?.size > DBMAXSIZE) return;
      const payload = {
        data,
        expiresOn: getExpiryDate()
      };
      await cacheProvider.setItem(key, payload);
    } catch (error) {
      console.log(
        `Encountered an error while setting value for key: ${key} and Error: ${error}`
      );
    }
  };

  return {
    getItem,
    setItem,
    removeItem
  };
};
